<template>
    <div>
        <!-- formulario del Resource -->
        <v-form ref="formDatosImport" lazy-validation>
            <v-dialog v-model="estadoComp" persistent scrollable max-width="30%">
                <v-card>

                    <v-card-title class="btn_otro">
                            {{ formTitle }}
                            <v-spacer></v-spacer>
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-card-title> 

                    <v-divider></v-divider>

                    <v-card-text class="pt-5">
                        <v-row>   
                            <v-col cols="12" md="12" lg="12" >                               
                                <template>
                                    <v-file-input v-model="data.archivo"  label="Documentos" ref="myFile"
                                        @change="OnArchivoChange"  :rules="[rul.required, rul.max5Mb]" 
                                        show-size accept=".ppt,.pptx, .pdf" >
                                    </v-file-input>                    
                                </template>
                            </v-col>
                        </v-row>    
                        <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
                        <v-col class="d-flex flex-row-reverse pt-0">
                            <v-btn class="btn_otro" :loading="loading" :disabled="loading" @click="SaveItem()">
                                <v-icon left>fa-upload</v-icon>
                                Cargar recurso
                            </v-btn>
                        </v-col>
                    </v-row>          
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-form>
    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import {mapMutations, mapGetters, mapActions} from 'vuex';

    export default {
        name:'resource',
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },        
        },        
        components:{
        }, 
        data: () => ({
            paramComponente:{ 'id_submodulo':1, "id_modulo": 4}, //sud_modulo y modulo
            datoLogin: sessionStorage, // variables de sesion del usuario
            test: false, 
            search: '',
            data: {},
            
            formTitle: 'Importar recursos',
            iconoFile:'',
            typefFile:'',
            disabledFile: true, 
            nombreArchivo:'',

            archivoTemp : '',
            
            rul: {
                required: value => !!value || 'Campo requerido',
                inputReq: value => !!value || 'Campo requerido',
                // selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                selectReq: v =>(!v || v != -1 )|| 'Debe seleccionar un campo de la lista',
                email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo es incorrecto',
                min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',
                max5Mb: v => !v || v.size < 5000000 || 'El tamaño del documento debe ser inferior a 5 MB!',
                max10Mb: v => !v || v.size < 10000000 || 'El tamaño del documento debe ser inferior a 10 MB!',
            },
            loading: false,
        }),
        computed: {
            ...mapGetters('login', [ 'componenteEvento']),       
        },
        mounted() {
            this.LoadMain()
        },
        created(){
            this.actualizarParamentro()
        },        
        watch: {
            estadoComp() {
                if(this.estadoComp){
                    this.LoadMain()                    
                }else{   
                    this.LimpiarForm()                 
                }                
            }
        },
        methods: {
            ...mapActions('login',['parametroComponente'] ),
            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            async LoadMain(){
                this.LimpiarForm()

            },           
            OnArchivoChange(e) {
                console.log(e);
                if (e !== undefined) {
                    this.archivoTemp = e;
                }else{
                    this.archivoTemp = null;
                }
            },
            async SaveItem(){
                if (!this.$refs.formDatosImport.validate()) {
                    
                    this.setEnviarMens({tipo:"W", mensaje: `Debe de ingresar todos los campos requeridos`, tiempo:null})
                    return
                }
                this.loading = true;
                let formData = new FormData()  
                formData.append('id_pais',  this.parametros.items.id_pais)
                formData.append('id_clase', this.parametros.items.id_clase)
                formData.append('id_tema',  this.parametros.items.id_tema)
                formData.append('id_nivel', this.parametros.items.id_nivel)
                formData.append('id_area',  this.parametros.items.id_area)
                formData.append('id_usuario', this.datoLogin.id)                
                formData.append('archivo', this.archivoTemp)

                try{
                    let response = await  axios.post( '/manager/fileS3/gestorContenido/importDoc/',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    // this.addCuadernoTrabajo(response);
                    this.setEnviarMens({tipo:`${response.data.messageT}`, mensaje:`${response.data.message}`, tiempo:null})
                    this.$refs.myFile.reset();
                    this.$emit('close', response.data.data)       
                }catch(error){
                    console.log(error)                
                }
                this.loading = false;
            },

            LimpiarForm(){
                this.$refs.formDatosImport.resetValidation()
            },
        },

    }
</script>

<style scoped>
</style>